export function askForAuthenticationPreservingRoute() {
  return window.location.replace(
    `/${
      !!window.location.pathname.length
        ? "?redirect_to=" + window.location.pathname
        : ""
    }`
  );
}
